import { connect } from 'react-redux';
import ScientificWork from '../../components/scientificWork/ScientificWork';
import { list } from '../../actions/faculty';
import * as facultyActions from '../../actions/scientificWork';
import { fetchDivisions } from '../../actions/personnel';


const mapStateToProps = ({faculty, scientificWork, personnel}) => (
    {
    facultyList: faculty.list,
    divisions: personnel.divisions, 
    scientificWorkYear: scientificWork.scientificWorkYear,
    scientificWorkTypeof: scientificWork.scientificWorkTypeof,
    scientificWorkList: scientificWork.scientificWorkList,
    isError: scientificWork.isError,
    isLoading: scientificWork.isLoading,
    pagesCount: scientificWork.pagesCount,
});



const mapDispatchToProps = dispatch => ({
    fetchFacultyList: () => dispatch(list()),
    fetchDivisions: () => dispatch(fetchDivisions()),
    fetchYear: () => dispatch(facultyActions.getScientificWorkYear()),
    fetchTypeof: () => dispatch(facultyActions.getScientificWorkOrdertype()),
    fetchList: (params) => dispatch(facultyActions.getScientificWorkList(params))
});



export default connect(mapStateToProps, mapDispatchToProps)(ScientificWork);
